export default /* glsl */`
#ifdef USE_MAP

	float tintAccumulatedInfluence = tintInfluence;

#endif
`;
